import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Product } from '@app/models';
import { environment } from '@environments/environment';
import * as FileSaver from 'file-saver/FileSaver';

const API = environment.API;

interface GetOptions {
  FollowId?: number;
  deletedAt?: boolean;
  type?: 'minimal';
  condition?: any;
  valueCondition?: number;
}

@Injectable({
  providedIn: 'root'
})
export class ProductService {
  constructor(private http: HttpClient) {}

  get(options?: GetOptions) {
    let queries = [];

    if (options && options.FollowId) {
      queries = [...queries, `FollowId=${options.FollowId}`];
    }
    if (options && options.deletedAt) {
      queries = [...queries, `deletedAt=${options.deletedAt}`];
    }

    if (options && options.type) {
      queries = [...queries, `type=${options.type}`];
    }

    if (options && options.condition) {
      // console.log('----', options);
      switch (options.condition) {
        case 'ProviderId':
          queries = [...queries, `ProviderId=${options.valueCondition}`];
          break;

        case 'BrandId':
          queries = [...queries, `BrandId=${options.valueCondition}`];
          break;

        case 'season':
          queries = [...queries, `season=${options.valueCondition}`];
          break;

        case 'BuyerId':
          queries = [...queries, `BuyerId=${options.valueCondition}`];
          break;
      }
    }

    const query = queries.length ? `?${queries.join('&')}` : '';
    // console.log('----', query);
    return this.http.get<Product[]>(`${API}products${query}`);
  }

  getOne(id) {
    return this.http.get<Product>(`${API}products/${id}`);
  }

  // getFilterPro(filter) {
  //   return this.http.get<Product[]>(
  //     `${API}products/${filter.condition}/${filter.valueCondition}`
  //   );
  // }

  create(data) {
    return this.http.post<Product>(`${API}products`, data);
  }

  duplicate(FollowId, ProductIds) {
    return this.http.post<Product[]>(`${API}products/duplicate`, {
      FollowId,
      ProductIds
    });
  }

  bulkUpdate(data) {
    return this.http.put<Product[]>(`${API}products`, data);
  }

  restoreTrash(FollowId) {
    return this.http.post<any>(`${API}products/restore`, {
      FollowId
    });
  }

  emptyTrash(FollowId) {
    return this.http.post<any>(`${API}products/destroy?empty=true`, {
      FollowId
    });
  }

  // destroySingle(ProductId) {
  //   return this.http.delete<any>(`${API}products/${ProductId}`);
  // }

  destroySingle(ProductId) {
    return this.http.post<any>(`${API}products/trash`,{ProductId});
  }

  update(id, changes) {
    return this.http.put<Product>(`${API}products/${id}`, changes);
  }

  search(conditions: any[], FollowId?: number) {
    const data = [...conditions, { key: 'FollowId', value: FollowId }];

    return this.http.post<any>(`${API}products/search`, data);
  }

  bulkDestroy(FollowId: number, ProductIds: number[]) {
    return this.http.post<any>(`${API}products/destroy`, {
      FollowId,
      ProductIds
    });
  }

  bulkAlive(FollowId: number, ProductId) {
    return this.http.put<any>(`${API}products/${ProductId}/alive`, {
      FollowId,
      ProductId
    });
  }

  getByCountryDepartment(
    FollowId,
    countryDepartmentId,
    CountryId?,
    businessUnit?,
    typeHierarchy?,
    DestinationCenterId?
  ) {
    // let queries = [];
    // const params = { nameDepartment };
    //console.log(CountryId);
    // queries = [...queries, `countryGroupDescription=${nameDepartment}`];
    return this.http.get<Product[]>(
      `${API}products/${FollowId}/showroom/products?${
        countryDepartmentId ? 'CountryDepartmentId=' + countryDepartmentId : ''
      }${CountryId ? '&CountryId=' + CountryId : ''}${
        businessUnit && CountryId ? '&businessUnit=' + businessUnit : ''
      }${typeHierarchy ? '&typeHierarchy=' + typeHierarchy : ''}${
        DestinationCenterId ? '&DestinationCenterId=' + DestinationCenterId : ''
      }`
    );

    // return this.http.get<Product[]>(
    //   `${API}products/${FollowId}/reports/productsShowroom${queries}`
    // );
  }

  deleteTechnicalFile(productId){
    return this.http.delete<any>(`${API}products/showroom/food/technicalFile/${productId}`)
  }

  downloadTechnicalFile(productId){
    const data = {
      productId: productId
    }
    return this.http.post<any>(`${API}products/showroom/food/technicalFile`, data)
  }

  sendProductsLikesMailForFoodShowroom(data){
    return this.http.post<any>(`${API}products/showroom/food/mail`, data)
  }

  getProductsForFoodShowroom(followId){
    return this.http.get<any>(`${API}products/showroom/food?FollowId=${followId}`)
  }

  updateOneProductsForFoodShowroom(productId, claims){
    const data = {
      productId: productId,
      claims: claims
    }
    return this.http.put<any>(`${API}products/showroom/food`, data)
  }

  upsertProductsLikesForFoodShowroom(data){
    return this.http.post<any>(`${API}products/showroom/food`, data);
  }

  downloadWhishlist(data){
    const { fileName, downloadlink } = data
    return this.http
      .get(downloadlink, {
        responseType: 'blob',
        observe: 'response'
      })
      .subscribe(
        response => {
          const blob = response.body;
          FileSaver.saveAs(blob, fileName);
          // this.store.dispatch(new FileActions.ExportFollowSuccess());
        },
        err => {
          // this.store.dispatch(new FileActions.ExportFollowFail());
          console.log('err => ',err)
        }
      );
  }
}
